// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./bootstrap.rtl.min.css";
// import "./index.css";
// import App from "./App";
// import { Provider } from "react-redux";
// import { ThemeProvider } from "react-bootstrap";
// import store from "./redux-state/store";
// import { BrowserRouter, Route, Routes } from "react-router";
// import UsersManagement from "./admin/users-management";
// import Home from "./admin/Home";
// import UsersAcountsManagement from "./admin/usersAcountsManagement";
// import StoreManagent from "./store";
// import Inventory from "./inventory";
// import ManagerHome from "./manager/managersHome";
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <ThemeProvider dir="rtl">
//         <BrowserRouter>
//           <Routes>
//             <Route path="/" element={<App />}>
//               <Route index element={<Home />} />
//               <Route path="admin-user" element={<UsersAcountsManagement />} />
//               <Route path="store" element={<StoreManagent />} />
//               <Route path="inventory" element={<Inventory />} />
//               <Route path="managerHome" element={<ManagerHome />} />
//             </Route>
//           </Routes>
//         </BrowserRouter>
//       </ThemeProvider>
//     </Provider>
//   </React.StrictMode>
// );
import React from "react";
import ReactDOM from "react-dom/client";
import "./bootstrap.rtl.min.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { ThemeProvider } from "react-bootstrap";
import store from "./redux-state/store";
import { BrowserRouter, Routes, Route } from "react-router"; // Correct import
import UsersManagement from "./admin/users-management";
import Home from "./admin/Home";
import UsersAcountsManagement from "./admin/usersAcountsManagement";
import StoreManagent from "./store";
import Inventory from "./inventory";
import ManagerHome from "./manager/managersHome";
import Admin from "./admin";
import Manager from "./manager";
import User from "./user";
import LogIn from "./logIn/login";
import LogInIndex from "./logIn";
import MaintenanceOfficer from "./MaintenanceOfficer";
import MaintenanceHome from "./MaintenanceOfficer/maintenanceHome";
import Supply from "./admin/supply";
import Settings from "./admin/settings";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider dir="rtl">
        {/* Wrap the entire app with BrowserRouter */}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />}>
              {/* Public Routes */}
              <Route index element={<LogIn />} />
              {/* Protected Routes */}

              <Route path="admin" element={<Admin />}>
                <Route index element={<Home />} />
                {/* <Route path="users" element={<UsersManagement />} /> */}
                <Route path="accounts" element={<UsersAcountsManagement />} />
                <Route path="store" element={<StoreManagent />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="invoice" element={<Supply />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              {/* Manager Routes */}
              <Route path="manager" element={<Manager />}>
                <Route index element={<ManagerHome />} />
                <Route path="store" element={<StoreManagent />} />
                <Route path="inventory" element={<Inventory />} />
              </Route>
              {/* maintenance user  */}
              <Route path="maintenance" element={<MaintenanceOfficer />}>
                <Route index element={<MaintenanceHome />} />
              </Route>
              {/** inventory  */}
              <Route path="inventory" element={<Inventory />}></Route>

              {/* User Routes */}
              <Route path="user" element={<User />}>
                {/* Add user-specific routes here */}
              </Route>
            </Route>
            {/* Admin Routes */}
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
